export default "__VITE_ASSET__18b98957__"